/**
 * Session card for a person who signed in without an organisation.
 */
export class AccountSessionDto {
  id!: number;
  uuid!: string;
  handle!: string;
  firstName?: string | null;
  lastName?: string | null;
  profileComplete!: boolean;
}
